import { DatePicker, Table, TableColumn, Select, Option, Popover } from 'element-ui';
import { Switch as LSwitch } from '@/components/index';
import { Pagination as LPagination } from '@/components/index';
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

export default {
    name: 'AdminRefundsTab',
    components: { LPagination, [Select.name]: Select, [Option.name]: Option, [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, LSwitch, [Popover.name]: Popover },
    data() {
        return {
            pagination: {
                perPageOptions: [5, 10, 25, 50],
                currentPage: 1, perPage: 5, total: 0, from: 0, to: 0
            },
            tableColumns: [],
            tableData: [],
            pickerOptionsFrom: {
                shortcuts: [{
                    text: 'Now',
                    onClick(picker) { picker.$emit('pick', new Date()); }
                },
                {
                    text: 'Week ago',
                    onClick(picker) { const date = new Date(); date.setTime(date.getTime() - 3600 * 1000 * 24 * 7); picker.$emit('pick', date); }
                },
                {
                    text: 'Month ago',
                    onClick(picker) { const date = new Date(); date.setTime(date.getTime() - 3600 * 1000 * 24 * 30); picker.$emit('pick', date); }
                }],
            },
            pickerOptionsTo: {
                shortcuts: [{
                    text: 'Now',
                    onClick(picker) { picker.$emit('pick', new Date()); }
                },
                {
                    text: 'In one week',
                    onClick(picker) { const date = new Date(); date.setTime(date.getTime() + 3600 * 1000 * 24 * 7); picker.$emit('pick', date); }
                },
                {
                    text: 'In one month',
                    onClick(picker) { const date = new Date(); date.setTime(date.getTime() + 3600 * 1000 * 24 * 30); picker.$emit('pick', date); }
                }]
            },
            params: { purchaseType: '', itemId: 0, dateFrom: null, dateTo: new Date(), searchType: 0, searchQuery: '', itemYear: null },
            savedParams: null,
            searchQuery: '',
            itemType: '',
            getAllRefunds: false,
            isLoading: false,
            paymentTypes: [],
            searchTypes: [],
            items: [],
            yearSelect: [],
            currentYear: new Date().getFullYear(),
            isAnyPaymentForNextYear: false
        };
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (row.status == 3) {
                return 'row-confirmed';
            }
            else if (row.status == 5) {
                return 'row-cancelled';
            }
            else {
                return '';
            }
        },
        formatDate(d) {
            var day = d.getDate();
            if ((day + '').length == 1) day = '0' + day;

            var month = d.getMonth() + 1;
            if ((month + '').length == 1) month = '0' + month;

            var hours = d.getHours();
            if ((hours + '').length == 1) hours = '0' + hours;

            var minutes = d.getMinutes();
            if ((minutes + '').length == 1) minutes = '0' + minutes;

            var seconds = d.getSeconds();
            if ((seconds + '').length == 1) seconds = '0' + seconds;

            var pretty_date = [d.getFullYear(), month, day].join('-');
            var pretty_time = [hours, minutes, seconds].join(':');

            return pretty_date + 'T' + pretty_time + '.000Z';
        },
        getParams() {
            if (this.savedParams && JSON.parse(this.savedParams).purchaseType != this.params.purchaseType) {
                this.params.itemId = 0;
                this.params.itemYear = null;
            }
            var params = {
                purchaseType: this.params.purchaseType,
                itemId: this.params.itemId,
                itemYear: this.params.itemYear,
                dateFrom: this.params.dateFrom,
                dateTo: this.params.dateTo,
                take: this.pagination.currentPage * this.pagination.perPage,
                skip: (this.pagination.currentPage - 1) * this.pagination.perPage,
                searchQuery: this.params.searchQuery,
                searchType: this.params.searchType
            };

            return params;
        },
        yearChanged() {
            this.params.itemId = 0;
        },
        changeGetAllRefunds() {
            if (this.getAllRefunds) {
                this.params.dateFrom = null;
                this.params.dateTo = null;
            }
            this.queriedData()
        },
        changeDate(from) {
            this.getAllPayments = false;
            var oldParamsDateFrom = JSON.parse(this.savedParams).dateFrom;
            var oldParamsDateTo = JSON.parse(this.savedParams).dateTo;

            if (oldParamsDateFrom && this.params.dateFrom && this.params.dateFrom.getFullYear() != new Date(oldParamsDateFrom).getFullYear()) {
                this.params.itemId = 0;
            }

            if (oldParamsDateTo && this.params.dateTo && this.params.dateTo.getFullYear() != new Date(oldParamsDateTo).getFullYear()) {
                this.params.itemId = 0;
            }

            this.queriedData();
        },
        getPaymentsByYear() {
            if (this.selectedYear) {
                if (!this.params.dateFrom || this.params.dateFrom.getFullYear() != this.selectedYear) {
                    this.params.dateFrom = new Date(this.selectedYear, 0, 1);
                }
                if (!this.params.dateTo || this.params.dateTo.getFullYear() != this.selectedYear) {
                    this.params.dateTo = new Date(this.selectedYear, 11, 31);
                }
                this.queriedData(false)
            }
        },
        queriedData() {
            var self = this;
            var params = this.getParams();
            if (JSON.stringify(params) != this.savedParams) {
                self.savedParams = JSON.stringify(params);
                return self.loadData(params);
            }
            return self.tableData;
        },
        getFrom() {
            if (!this.pagination.total) {
                return 0
            }
            else {
                return (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
            }
        },
        getTo() {
            if (!this.pagination.total) {
                return 0;
            }
            else
                if ((this.pagination.currentPage) * this.pagination.perPage > this.pagination.total) {
                    return this.pagination.total;
                }
                else {
                    return (this.pagination.currentPage) * this.pagination.perPage;
                }
        },
        loadData(params) {
            var self = this;
            if (params.dateFrom) {
                params.dateFrom = self.formatDate(params.dateFrom);
            }

            if (params.dateTo) {
                params.dateTo = self.formatDate(params.dateTo);
            }

            svc.getRefunds(params)
                .then((resp) => {
                    var allData = resp.body;
                    if (!allData == null) return [];

                    self.tableData = allData.refunds;
                    self.currentYear = allData.currentYear;
                    self.isAnyPaymentForNextYear = allData.isAnyPaymentForNextYear;
                    self.updateYearSelect();

                    self.pagination.total = allData.total;
                    self.pagination.from = self.getFrom();
                    self.pagination.to = self.getTo();

                    if (!self.paymentTypes.length) {
                        self.paymentTypes = allData.paymentTypes;
                    }
                    if (!self.searchTypes.length) {
                        self.searchTypes = allData.searchTypes;
                    }
                    if (!allData.selectedItem) {
                        self.items = allData.items;
                    }
                    else {
                        self.params.itemId = allData.selectedItem;
                    }

                    self.itemType = allData.itemTypeString;
                },
                    () => { return []; });
        },
        exportData() {
            var self = this;
            if (!self.tableData || !self.tableData.length) {
                self.$notify({ message: 'There is no payments to export', type: 'danger' });
                return;
            }

            var params = self.getParams();
            params.skip = 0;
            params.take = 10000;

            if (params.dateFrom) {
                params.dateFrom = self.formatDate(params.dateFrom);
            }
            if (params.dateTo) {
                params.dateTo = self.formatDate(params.dateTo);
            }

            self.isLoading = true;
            svc.getRefunds(params)
                .then((resp) => {
                    var allData = resp.body;
                    if (!allData || !allData.refunds && !allData.refunds.length) {
                        self.$notify({ message: 'Payments records not received, something went wrong, please contact with dev team', type: 'danger' });
                        return;
                    }
                    self.exportToExcel(allData.refunds);
                    self.$notify({ message: 'Refunds successfully saved', type: 'success' });
                    self.isLoading = false;
                },
                    (resp) => {
                        self.$notify({ message: 'Something went wrong, please contact with dev team: ' + resp.body, timeout: 60000, type: 'danger' });
                        self.isLoading = false;
                    });
        },
        exportToExcel(data) {
            if (data && data.length) {
                var sheetData = [];
                data.forEach((item) => {
                    sheetData.push({
                        "Refund Date": item.refundDateString,
                        "Paid By TI Number": item.payment.paydByTiId,
                        "Paid For TI Number": item.payment.userTiId,
                        "Paid For First Name": item.payment.firstName,
                        "Paid For Last Name": item.payment.lastName,
                        "Purchase Type": item.payment.purchaseTypeString,
                        "Payment Price": item.payment.price,
                        "Refunded Price": item.refundAmount,
                        "Refund Transaction Code": item.refundTransactionCode,
                        "Refund Reason": item.refundReason,
                        "Payment Item Description": item.payment.description,
                        "Payment Item Transaction Date": item.payment.paymentDateString,
                        "Payment Item Transaction Code": item.payment.transactionCode,
                        "Payment Item Status": item.payment.statusString,
                        "Refund Created By": item.createdByUserName,
                        "Refund Created By TI Number": item.createdByUserTiId,
                    });
                });

                var ws = XLSX.utils.json_to_sheet(sheetData);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Refunds");

                var total = this.pagination.total;
                if (total > 10000) total = 10000;
                XLSX.writeFile(wb, "Refunds (" + total + ")" + this.createDateRangeText(this.params.dateFrom, this.params.dateTo) + ".xlsx");
            }
        },
        createDateRangeText(dateFrom, dateTo) {
            var result = ''
            if (dateFrom) {
                result = " from " + dateFrom.yyyymmdd();
            }
            if (dateTo) {
                if (dateFrom && dateTo.getDay() == dateFrom.getDay() && dateFrom.getMonth() == dateTo.getMonth() && dateFrom.getFullYear() == dateTo.getFullYear()) {
                    result = " on " + dateTo.yyyymmdd();
                }
                else {
                    result = result + " until " + dateTo.yyyymmdd();
                }
            }
            if (!result) {
                result = result + ' until' + new Date().yyyymmdd()
            }
            return result;
        },
        updateYearSelect() {
            var lastYear = this.currentYear;

            if (!this.yearSelect.length) {
                while (lastYear > 2009) {
                    this.yearSelect.push(lastYear);
                    lastYear = lastYear - 1;
                }
            }
        },
        setInitialParams() {
            var self = this;

            if (!Date.prototype.yyyymmdd) {
                Date.prototype.yyyymmdd = function () {
                    var mm = this.getMonth() + 1; // getMonth() is zero-based
                    var dd = this.getDate();
                    return [this.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
                };
            }

            EventBus.$off("admin_load_refunds");
            EventBus.$on("admin_load_refunds", () => { self.savedParams = null; self.queriedData(); });
        },
        viewTransaction(paymentId) {
            EventBus.$emit("admin_view_transaction", paymentId);
        }
    },
    created() {
        this.setInitialParams();
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/payments/refunds-tab/refunds-tab.js